<template>
  <section id="contact-strip" class="contact-form-block">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="banner-lead-form">
            <h3>{{ $t('contactForm.title') }}</h3>
            <p>{{ $t('contactForm.subtitle') }}</p>

            <form @submit.prevent="submitForm">
              <div class="form-group">
                <input
                  type="text"
                  v-model="leadForm.nombre"
                  :placeholder="$t('contactForm.name')"
                  required
                />
              </div>

              <div class="form-group">
                <input
                  type="text"
                  v-model="leadForm.empresa"
                  :placeholder="$t('contactForm.company')"
                />
              </div>

              <div class="form-group">
                <input
                  type="tel"
                  v-model="leadForm.telefono"
                  :placeholder="$t('contactForm.phone')"
                  required
                />
              </div>

              <div class="form-group">
                <input
                  type="email"
                  v-model="leadForm.email"
                  :placeholder="$t('contactForm.email')"
                  required
                />
              </div>

              <div class="form-group">
                <textarea
                  v-model="leadForm.mensaje"
                  :placeholder="$t('contactForm.message')"
                  rows="3"
                ></textarea>
              </div>

              <button
                class="cmn-banner-btn w-100"
                type="submit"
                :disabled="isSending"
              >
                <i class="bx bx-send"></i>
                {{ isSending ? $t('contactForm.sending') : $t('contactForm.submit') }}
              </button>

              <p v-if="sendOk" class="form-success">
                {{ $t('contactForm.success') }}
              </p>

              <p v-if="sendError" class="form-error">
                {{ $t('contactForm.error') }}
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactFormBlock',
  data() {
    return {
      leadForm: {
        nombre: '',
        empresa: '',
        telefono: '',
        email: '',
        mensaje: '',
      },
      isSending: false,
      sendOk: false,
      sendError: false,
    };
  },
  methods: {
    async submitForm() {
      this.isSending = true;
      this.sendOk = false;
      this.sendError = false;

      try {
        await axios.post('/api/contact', this.leadForm);

        this.sendOk = true;
        this.leadForm = {
          nombre: '',
          empresa: '',
          telefono: '',
          email: '',
          mensaje: '',
        };
      } catch (err) {
        console.error(err);
        this.sendError = true;
      } finally {
        this.isSending = false;
      }
    },
  },
};
</script>

<style scoped>
.contact-form-block {
  position: relative;
  background: #2f0f34 url('@/assets/img/resources/address-bg.png') no-repeat center center;
  background-size: cover;
  color: #fff;
  padding: 60px 0;
  z-index: 1;
}

.contact-form-block::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* más claro: reducimos la opacidad de la capa oscura */
  background: rgba(15, 15, 16, 0.45);
  z-index: -1;
}


.banner-lead-form {
  background: #1a1a1d;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}

.banner-lead-form h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #fff;
  text-align: center;
}

.banner-lead-form p {
  font-size: 15px;
  text-align: center;
  color: #bbb;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 12px;
}

input,
textarea {
  width: 100%;
  background: #2a2a2f;
  border: 1px solid #444;
  border-radius: 6px;
  padding: 12px;
  font-size: 14px;
  color: #fff;
  outline: none;
  transition: border 0.2s ease;
}

input:focus,
textarea:focus {
  border-color: #4ea1ff;
}

button.w-100 {
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 15px;
}

.form-success {
  color: #6ddf7c;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.form-error {
  color: #ff6b6b;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}
</style>
